import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import { getNodeById } from "../../../nodeSelector";
import * as nodeUtils from "../../../utils/nodeUtils";
import * as pathUtils from "../../../utils/pathUtils";
import * as systemUtils from "../../../utils/systemUtils";
import { ACTION_PREFIX_CONDITION } from "./abstract/conditionAbstract";

const _action = `${ACTION_PREFIX_CONDITION}_update_expression`;
const _header = `Update condition expression`;

export const updateConditionExpression = (root, id, expression) => {
  const _payload = updateConditionValueLogic(root, id, expression);

  logger.logAction(_action, _payload, ACTION_PREFIX_CONDITION);

  return { root, info: _payload };
};

//--------------------------------------------------------------------------------

export const updateConditionValueLogic = (root, id, expression) => {
  const { data: _node, index: _index } = getNodeById(root, id);

  if (!_node) {
    throw new Error("Condition to update not found");
  }

  if (nodeUtils.getExpression(_node) === expression) {
    return generatePayloadIndifferent();
  }

  const { data: _nodeParent } = getNodeById(root, pathUtils.getIdParent(id));

  const _nodeBackup = systemUtils.createDeepCopy(_node);

  nodeUtils.setExpression(_node, expression);

  return generatePayload(_nodeBackup, _index, _nodeParent, nodeUtils.getValue(_node));
};

//--------------------------------------------------------------------------------

const generatePayloadIndifferent = () => {
  const _payload = {
    status: ActionStatusTypes.INDIFFERENT,
    action: _action,
    time: systemUtils.getTimestamp(),
  };

  return _payload;
};

const generatePayload = (node, index, nodeParent, expressionAfter) => {
  return {
    group: ActionGroupTypes.UPDATE,
    status: ActionStatusTypes.SUCCESS,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: generatePayloadDescription(node, nodeParent),
    node: node,
    uuid: nodeUtils.getUUID(node),
    uuidParent: nodeUtils.getUUID(nodeParent),
    index: index,
    expressionBefore: nodeUtils.getExpression(node),
    expressionAfter: expressionAfter,
  };
};

const generatePayloadDescription = (node, nodeParent) => {
  if (nodeUtils.isFunction(nodeParent)) {
    return `Update function logic '${nodeUtils.getName(node)}'.`;
  }

  return `Update structure logic '${nodeUtils.getName(node)}'.`;
};
